import { useSyncExternalStore } from "react";

const subscribeToRootClass = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
  return () => observer.disconnect();
};

const readRootIsDark = () =>
  document.documentElement.classList.contains("dark");

/**
 * Whether the app is showing its dark theme right now.
 *
 * Reads the `dark` class the theme provider puts on `<html>`, which is already
 * resolved from the user's choice and, for "system", the OS preference. Use it
 * for third-party renderers that pick colours in JavaScript and cannot follow
 * the class through CSS.
 */
export const useIsDarkMode = (): boolean =>
  useSyncExternalStore(subscribeToRootClass, readRootIsDark, () => false);
